// initializing
(function() {
  $(document).ready(function() {
    $(".swell-referral-back-link").click(function(e){
      $(".swell-reward-postcheckout").hide();
    });

    $(".redeem").click(function(){
      if(this.id == "discounts") {
        $('.redeem-point-list').addClass("display-none");
        $('.redeem-discount').removeClass("display-none");
        $('#discounts').addClass("active");
        $('#products').removeClass("active");
      } else if(this.id == "products") {
        $('.redeem-discount').addClass("display-none");
        $('.redeem-point-list').removeClass("display-none");
        $(".slick-next").click();
        $('#products').addClass("active");
        $('#discounts').removeClass("active");
      }
    });

    $(document).on("swell:setup", function() {
      if(window.location.href.indexOf("rewards") > -1 ||  window.location.href.indexOf("account") > -1) {
        setupCouponOnRewardsAndAccountPage(".swell-redemption-option-list-rewards");
      }
      Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
      SwellConfig.Campaign.authenticate();
      $(".campaign-spinner").hide();
      SwellConfig.Referral.initializeReferral(".swell-referral");
      $(".referral-spinner").hide();
      $(".swell-reward-postcheckout").show();

      if(window.location.href.indexOf("cart") > -1) {
        setupCartBasedCoupons(".swell-cart-based-coupon");
      }

      Swell.Redemption.initializeProductRedemptions(".swell-product-redemption-options",SwellConfig.Redemption.opts);
      SwellConfig.Redemptions.initializeSlider('.swell-redemption-products');
      SwellConfig.Redemptions.initializeProducts();
      $(".redeem-spinner").hide();
      $('.slick-track').attr('aria-label', 'Redeem for Hint Products');
      // cart discount redemption
      $(".swell-cart-discount-redemption-btn").click(function(){
        redemptionOptionId = $(this).data("redemption-option-id");
        redemptionOption = swellAPI.findActiveRedemptionOptionById(redemptionOptionId);

         if(redemptionOption.amount <= spapi.customer.adjusted_points_balance){
          $(this).html("<i class='fa fa-spin fa-spinner'></i>");
          result = swellAPI.buyMultipleWithPoints([redemptionOption], function(){});
         }
        else
        {
          onError();
        }
      });

      function onError() {
        $(".swell-cart-error-message").html("<p>You don't have enough points to redeem this discount</p>");
      }

      if(window.location.href.indexOf("cart") > -1) {
        Swell.Cart.items.forEach(function(item) {
          if (item.properties._swell_discount_type == "cart_fixed_amount") {
            redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
            $(".cart-table tbody").append('<tr class="swell-coupon-row cart__row"><td class="cart__product-image-wrapper"></td> <td class="cart__product-title"> <div class="swell-coupon-image-holder">' + redeemedRedemptionOption.name + '</div> </td> <td class="cart__product-title"> ' + redeemedRedemptionOption.name + ' <br> <span> Rewards</span> </td> <td class="swell-coupon-quantity quantity"> <input type="text" readonly class="field styled-input" name="" id="" value="1"> </td> <!--<td class="cart__product-frequency"></td>-->  <td class="cart__product-total-price"> - ' + redeemedRedemptionOption.amount + ' points </td> <td class="cart__remove swell-coupon-remove"> <a href="javascript:void(0)" class="cart__remove-button" >x</a> </td> </tr>');
            return
          }
        });

        $('body').on('click',".swell-coupon-remove", function() {
          $(".swell-coupon-remove").html("<i class='fa fa-spin fa-spinner'></i>");
           swellAPI.removeRedemptionOptionIdFromCart(redeemedRedemptionOption.id, function(){});
        });
      }

      $(document).on("swell:cart:updated", function(){
        window.location = "/cart";
      });

      $('body').on("click", ".reward-history", function () {
        var actions = spapi.customer.action_history_items.length;
        var actionsLeft =  spapi.customer.action_history_items.filter( function(act){
          var stat = act.status;
          if(stat != 'Approved' && stat != 'Refunded'){
            return act
          }
        })
        console.log('checking if has promo',actionsLeft.length)
        $("#history-model tbody").html("");
        for (i = 0; i < actions; i++) {
          pointRedemption = spapi.customer.action_history_items[i];
          date = pointRedemption.date;
          action = pointRedemption.action;
          credit = pointRedemption.points;
          status = pointRedemption.status;

          if(credit < 0){
            var pcredit = credit * -1 ;
          } else {
            var pcredit = credit
          }

          if( status != 'Approved' && status != 'Refunded' ) {
             $("#history-model tbody").append('<tr> <td>' + date +'</td> <td colspan="2">' + action +'</td> <td>' + pcredit +'</td> <td>' + status +'</td> </tr>');
          }
        }

        if(!actionsLeft.length && !$("#no-history").length){
           $('#history-model .history-modal-body').append('<p id="no-history" style="text-align:center;padding-top:30px">no actions</p>')
        }

        $("#history-model").css("display", "flex");

        element = document.querySelector(".history-modal-dialog")
        setTimeout(function() {
          trapFocus(element, "test")
        }, 500);
      });

      $("body").on("click", ".swell-custom-redemption", function (e) {
        $("#redemption-model #swell-reward-heading").html("");
        $("#redemption-model #swell-coupon-intro").html("");
        $("#redemption-model #swell-reward-intro").html("");
        $("#redemption-model #swell-coupon-code").html("");
        $(".redeem-btn").html("Redeem");

        redemptionOptionId = $(this).data("redemption-option-id");
        redemptionOption = spapi.findActiveRedemptionOptionById(redemptionOptionId);

        $("#redemption-model #swell-reward-heading").html(redemptionOption.name);
        $("#redemption-model #swell-coupon-intro").html(redemptionOption.description);
        $("#redemption-model").css("display", "flex");
        $("#redemption-model .redeem-btn").data("redemption-option-id", redemptionOptionId);
        $(".redeem-btn").show();

        setTimeout(function() {
          element = document.querySelector(".redemption-modal-dialog")
          trapFocus(element, "redemption-modal")
        }, 100);
      });

      $("body").on("click", "#redemption-model .redeem-btn", function (e) {
        e.preventDefault();
         redemptionId = $(this).data("redemption-option-id");
         $(".redeem-btn").html("Please wait...");

         var onRedemptionSuccess = function(redemption){
          $("#redemption-model #swell-reward-heading").html(redemption.redemptionOption.name);
          $("#redemption-model #swell-coupon-intro").html(redemption.redemptionOption.description);
          $("#redemption-model #swell-reward-intro").html(redemption.redemptionOption.reward_intro);
          $("#redemption-model #swell-coupon-code").html(redemption.couponCode);
          $("#redemption-model").css("display", "flex");
          $(".redeem-btn").hide();
         }

        var onError = function(err) {
          var heading = "Unable to redeem points...";
          $("#redemption-model #swell-reward-heading").html(heading);
          $("#redemption-model #swell-redemption-error").html("Sorry, you don't have enough points for this reward.");
          $("#redemption-model #swell-coupon-intro").html("");
          $("#redemption-model #swell-reward-intro").html("");
          $("#redemption-model").css("display", "flex");
          $(".redeem-btn").hide();
        }
        swellAPI.makeRedemption({redemptionOptionId: redemptionId,delayPointDeduction: true}, onRedemptionSuccess, onError);
      });

      $('body').on("click", ".swell-modal-close", function() {
        $(".swell-modal").hide();
      })

      function setupCouponOnRewardsAndAccountPage (containerSelector) {
        var redemptions = spapi.activeRedemptionOptions;

        redemptions.forEach(function(redemption) {
         if(redemption.discount_type == "shopify_recharge_fixed_amount") {
          id = redemption.id;
          name = redemption.name;
          cost_text = redemption.cost_text;
          image = redemption.background_image_url;

            if(image){
               cost_points = redemption.amount;
               $(containerSelector).append('<li class="swell-redemption-option"> <div class="swell-redemption-option-content swell-custom-redemption" data-redemption-option-id="' + id + '"> <a class="redemptions-link" href="#"> <div class="content-holder"> <img src="' + image + '" alt="redmeptions image"> <span class="swell-redemption-option-value"> ' + name + '</span> <span class="swell-redemption-option-cost-points">' + cost_points +' Points</span>  </div> <span class="swell-redemption-option-cost"> ' + cost_text + ' </span> </a> </div> </li> ');
            }
         }
        });
      }

      function setupCartBasedCoupons (containerSelector) {
        var redemptions = spapi.activeRedemptionOptions;

        redemptions.forEach(function(redemption) {
          if(redemption.discount_type == "cart_fixed_amount") {
            id = redemption.id;
            name = redemption.name;
            cost_text = redemption.cost_text;
            image = redemption.background_image_url;
            if(image){
                if (spapi.authenticated) {
                  $(containerSelector).append('<li class="swell-cart-discount-redemption-option swell-redemption-option clickable"> <div class="swell-cart-discount-redemption-option-content swell-cart-discount-redemption-btn swell-redemption-option-content" data-redemption-option-id="' + id + '"> <div class="content-holder"> <img src="' + image + '"> <span class="swell-redemption-option-value"> ' + name + '</span> <span class="swell-redemption-option-cost"> ' + cost_text + ' </span> </div> </div> </li>');
                }

                else {
                  $(containerSelector).append('<li class="swell-redemption-option"> <div class="swell-redemption-option-content" data-redemption-option-id="' + id + '"> <div class="content-holder"> <img src="' + image + '"> <span class="swell-redemption-option-value"> ' + name + '</span> <span class="swell-redemption-option-cost"> ' + cost_text + ' </span> </div> </div></li>');
                }
            }
          }
        });
      }


      if(spapi.authenticated) {
        $("#swell-reward-hint .refer-details").removeClass("display-none");
      }

      if(spapi.customer.referral_receipts != undefined && spapi.authenticated) {
        var html = '';
        var data   = {};
        var status = '';

        if(spapi.customer.referral_receipts.length==0){
          html = "<tr><td class='swell-no-referrals'>Currently you don't have any referrals</td><td></td></tr>";
        } else {
          data.d = spapi.customer.referral_receipts
          for(var i = 0; i < data.d.length; i++) {

            if(data.d[i].completed_at == null) {
              status = 'Invited';
            } else {
              status = 'Purchased($10 earned)';
            }

            html += '<tr><td>' + data.d[i].email +
              '</td><td>' + status + '</td></tr>';
          }
        }

        $("#rewards-balance-table .table-data").append(html);
      }
    });

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
      if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
        if (!$(".refer-to-old-customer-error")[0]) {
          $(".swell-referral-form-field-details").prepend('<p class="refer-to-old-customer-error">Oops! Looks like this person has already made a purchase. Try referring another friend.</p>');
          $("#swell-referral-refer-emails").addClass("error-border");
        }
      }
    });

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
      if(textStatus && textStatus === "Please enter a valid email address"){
        if (!$(".refer-customer-error")[0]) {
          $(".swell-referral-form-field-details").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
          $("#swell-referral-refer-emails").addClass("error-border");
        }
      }
    });

    $(document).on("swell:referral:success", function() {
      swellAPI.refreshCustomerDetails(function(){
        var customerDetails = swellAPI.getCustomerDetails();
        if(spapi.customer.referral_receipts != undefined) {

          var html   = '';
          var data   = {};
          var status = '';
          data.d = spapi.customer.referral_receipts

          var rowCount = $('#rewards-balance-table .table-data tr').length;

          if(rowCount==1 && spapi.customer.referral_receipts.length==1)
          {
            rowCount = 0;
          }

          for(var i = rowCount; i < data.d.length; i++) {
            if(data.d[i].completed_at == null) {
              status = 'Invited';
            } else {
              status = 'Purchased($10 earned)';
            }

            html += '<tr><td>' + data.d[i].email +
              '</td><td>' + status + '</td></tr>';
          }

          if(rowCount>0) {
            $('#rewards-balance-table .table-data tr').last().after(html);
          }
          else if(rowCount==0 && spapi.customer.referral_receipts.length==1) {
            $("#rewards-balance-table .table-data").html(html);
          }
          else {
            $("#rewards-balance-table .table-data").append(html);
          }
        }
      });
    });
  });
}).call(this);

function trapFocus(element, namespace) {
  var focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'),
      firstFocusableEl = focusableEls[0];
      lastFocusableEl = focusableEls[focusableEls.length - 1];
      firstFocusableEl.focus();
      KEYCODE_TAB = 9;

  element.addEventListener('keydown', function(e) {
      var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

      if (!isTabPressed) {
          return;
      }

      if ( e.shiftKey ) /* shift + tab */ {
          if (document.activeElement === firstFocusableEl) {
              lastFocusableEl.focus();
              e.preventDefault();
          }
      } else /* tab */ {
          if (document.activeElement === lastFocusableEl) {
              firstFocusableEl.focus();
              e.preventDefault();
          }
      }

  });
}

// campaigns
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: '<li class="swell-campaign"> <div class="swell-campaign-content" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <a class="campaign-link" href="javascript:void(0)"> <div class="swell-image-holder"> <img src="<%= campaign.background_image_url %>" alt=""> <div class="swell-content-holder"> <div class="swell-campaign-value"> <span class="swell-campaign-value-content"><%= campaign.reward_text %></span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content"><%= campaign.title %></span> </div> </div> </div> </a> </div> </li>',
        campaignHover: "<div class=\"swell-campaign-hover\">\n  <div class=\"swell-campaign-hover-content\">\n    <ul class=\"swell-link-list\">\n      <li class=\"swell-link\">\n        <a href=\"/account/login\" class=\"js-login-modal-trigger\" data-redirect=\"/rewards\">Sign In</a>\n      </li>\n      <li class=\"swell-link\">\n        <a href=\"/account/register\" class=\"swell-link-register\">Sign Up</a>\n      </li>\n    </ul>\n  </div>\n</div>"
      }
    },
    authenticate: function() {
      if (!spapi.authenticated) {
        spapi.$(document).off("click", ".swell-campaign-content");
        $(".swell-campaign").addClass("swell-campaign-login");
        $(".swell-campaign-content").hover(function() {
          $(this).append(SwellConfig.Campaign.opts.templates.campaignHover);
        }, function() {
          $(this).find(".swell-campaign-hover").remove();
        });

        $(".swell-redemption-option-content").hover(function() {
          $(this).append(SwellConfig.Campaign.opts.templates.campaignHover);
        }, function() {
          $(this).find(".swell-campaign-hover").remove();
        });
      }
    }
  };
}).call(this);

// history popup
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Customer = {
    initializeHistory: function(containerSelector) {
      return $(containerSelector).click(function() {
        return swellAPI.showPopupByType("HistoryPopup");
      });
    }
  };
}).call(this);

// links
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Link = {
    initializeLinks: function(containerSelector) {
      return $(document).on("click", containerSelector, function(e) {
        var href;
        e.preventDefault();
        href = $(this).attr("href");
        localStorage.setItem("swell-location", "/pages/rewards");
        return window.location = href;
      });
    }
  };
}).call(this);

// local storage
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.LocalStorage = {
    initializeLocalStorage: function() {
      var location;
      location = localStorage.getItem("swell-location");
      if (location && window.location.pathname === '/account') {
        localStorage.removeItem("swell-location");
        return window.location = location;
      }
    }
  };
}).call(this);

// redemption
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    opts: {
      templates: {
        redemptionOptionProduct: "<div class=\"swell-redemption-option\"> \n <div\n class=\"slide-img-holder swell-redemption-option-content\"\n data-confirm-title=\"Redeem your points?\" data-confirm-content=\"You currently have *|point_balance|* points. This costs *|amount|*. \" data-success-title=\"Success.\" data-success-content=\"This was successfully added to your cart.\" data-success-cart-btn=\"View Cart\" data-error-title=\"So close.\" data-error-content=\"This requires *|amount|* points and you only have *|point_balance|*. Earn more to be able to add this to your cart.\" data-variant-id=\"<%= redemption.applies_to_id %>\"\n  data-redemption-option-id=\"<%= redemption.id %>\"\n <div class=\"slide-img-holder\"> <img src=\"<%= redemption.background_image_url %>\"alt='redeem for products'>\n </div> \n <div class=\"swell-redemption-option-cost\"  > <%= redemption.cost_text %></div> \n <div class=\"swell-redemption-option-value\"><%= redemption.name %></div> \n </div>\n </div>"
      }
    }
  };
}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemptions = {
    initializeSlider: function(containerSelector){
      var slides;
      if(window.location.href.indexOf("account") > -1) {
        slides = 2;
      } else {
        slides = 4;
      }

      $(containerSelector).slick({
        slide: '',
        prevArrow:"<img alt='Previous slide' class='a-left control-c prev slick-prev' src='//cdn.shopify.com/s/files/1/0014/3015/9418/files/left-arrow.png?v=1626896859'>",
        nextArrow:"<img alt='Next slide' class='a-right control-c next slick-next' src='//cdn.shopify.com/s/files/1/0014/3015/9418/files/right-arrow.png?v=1626896859'>",
        dots: false,
        infinite: true,
        slidesToShow: slides,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true
            }
          }
        ]
      });
    },
    initializeProducts: function(){
      if (spapi.authenticated) {
        $(".swell-redemption-option-content").addClass("swell-buy-product-btn");
        return spapi.setupBuyProductWithPointsHelper();
      }
    }
  };
}).call(this);

// referral
(function() {
  window.SwellConfig = window.SwellConfig || {};
  var heart_img = "//www.drinkhint.com/cdn/shop/t/1532/assets/swell-copy-heart.png?358011";

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "Refer a Friend",
        referralSidebarDetailsReward: "",

        referralRegisterHeading: "<span class='refer-heading'>refer a friend</span><%= referralCampaign.reward_text %> discount for each successful referral",
        referralRegisterFormDetails: "Please submit your email to get started.",
        referralRegisterFormEmail: "example@gmail.com",
        referralRegisterFormSubmit: "send",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: "<span class='refer-heading'>refer a friend</span><%= referralCampaign.reward_text %> discount for each successful referral",
        referralReferFormEmails: "Enter your friends' emails (separated by commas)",
        referralReferFormSubmit: "send",
        referralReferFormDetails: "Enter your friends' emails below.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "You can also share your link with the buttons below",

        referralShareFacebook: "Share",
        referralShareTwitter: "Twitter",
        referralShareCopy: "Copy Link",

        referralFacebookIcon: "fa fa-facebook",
        referralTwitterIcon: "fa fa-twitter",
        referralLinkIcon: "icon-link-icon",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "Copy Link",
        referralCopyButton: "copy link",
        referralCopyDetails: "copy link and share with your friends"
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details">Give your friends $10 off their first purchase and Get $10 worth of hint rewards points for each successful referral. </p> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"> <%= localization.referralRegisterFormDetails %> </p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> </ul> </div> <div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </div> </form> <div class="swell-referral-footer"> <p>Or, if you don\'t have an account:</p> <a href="/account/register" class="sign-up-btn">sign up</a> </div> </div>',
        referralCopy: '<div class="swell-referral-copy"> <div class="swell-referral-copy-content"> <div class="swell-referral-copy-sidebar"></div> <div class="swell-referral-copy-main"> <span class="swell-referral-back-link"></span><div class="swell-copy-refer" <p>water that makes your friends <img src="' + heart_img + '"> water</p> </div> <p class="swell-referral-details"><%= localization.referralCopyDetails %></p> <h2 class="swell-referral-heading"> <i class="swell-referral-heading-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i> </h2> <div class="swell-referral-form-wrapper"> <div class="swell-referral-copy-link" id="swell-referral-copy-link"><%= customer.referralLink %></div> <button class="swell-referral-copy-button" id="swell-referral-copy-button" data-clipboard-target="#swell-referral-copy-link"><%= localization.referralCopyButton %></button> </div> </div> </div> <div>'
      }
    },
    initializeReferral: function(containerSelector) {
      var email = $(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
    }
  };
}).call(this);
